import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { ConvertBytesToImage } from "../Utils/Utils";
import { selectUserDetails } from "../Selectors/Selector";

function CartModal() {
    const cartDetails = useSelector((store) => store.cart?.data);
    const productDetails = useSelector((store) => store.products?.data);
    const userDetails = useSelector(selectUserDetails);
    const cartRowData = useMemo(() => {
        if (cartDetails?.length > 0 && productDetails?.length > 0) {
            return cartDetails.map((cart) => {
                let product = productDetails.find((p) => p.id === cart.productId)
                return {
                    cartId: cart.id,
                    quantity: cart.quantity,
                    productName: product.name,
                    price: product.price * cart.quantity,
                    image: product.image
                }
            })
        }
    }, [cartDetails, productDetails])

    const navigate = useNavigate();

    const onClickProceedToCart = (e) => {
        e.preventDefault(e);
        //setShowMobileHeader(false);
        navigate('/cart');
    }
    return (
        <div className="shopping-cart shopping-cart-empty dropdown-menu dropdown-menu-right"
            aria-labelledby="dropdownMenuButton">
            <ul className="shopping-cart-items">{
                userDetails ? <li>You have {cartDetails?.length} items in your cart.</li> :
                    <li>Login to see the items you added previously</li>
            }

            </ul>
            <ul className="shopping-cart-items cartItems">
                {cartRowData && cartRowData.length > 0 &&
                    cartRowData.map((item) => {
                            let imageUrl = ConvertBytesToImage(item.image);
                            return (
                                <li key={item.cartId} className="mini_cart_item">
                                    <div className="left-section">
                                        <a href="#">
                                            <img src={imageUrl} alt="" />
                                        </a>
                                    </div>
                                    <div className="right-section">
                                        {item.productName}
                                        <div>
                                            <div className="item-desc">Qty: {item.quantity}</div>
                                            <div className="item-desc">₹ {item.price}</div>
                                        </div>
                                    </div>
                                </li>
                            );
                    })
                }
            </ul>
            {cartDetails?.length > 0 &&
                <ul className="shopping-cart-items proceedToCart">
                    <li className="w-100 d-block" onClick={(e) => onClickProceedToCart(e)}>
                        <a href="#" className="btn btn-primary w-100 d-block">
                            Proceed to Cart
                        </a>
                    </li>
                </ul>
            }
        </div>
    );
}
export default CartModal;